import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Document } from '../document';
import { DocumentsService } from '../documents.service';
import { ListComponent, PopUpService } from '../../core';

@Component({
  selector: 'lms-documents-list',
  templateUrl: './documents-list.component.html',
  styleUrls: ['./documents-list.component.css']
})
export class DocumentsListComponent implements OnInit {
  @Input() clientId: string;
  @Input() listId: string;
  @Input() options: any;
  public listOptions: any = {
    sort: 'name',
    aggregates: ['numQuestions', 'numCustomizations', 'customizations'],
    elementsName: 'documents.label'
  };
  @ViewChild(ListComponent, { static: false }) public listComponent: ListComponent;

  documents: Document[];

  constructor(
    public documentsService: DocumentsService,
    public router: Router,
    public translate: TranslateService,
    public popupService: PopUpService
  ) {}

  ngOnInit() {
    Object.assign(this.listOptions, this.options);
  }

  setCollection(collection) {
    this.documents = collection;
  }

  deleteDocument(document) {
    if (document.numCustomizations) {
      this.popupService.showError({
        title: this.translate.instant('customizations.documents.deleteError'),
        text: this.translate.instant('customizations.documents.errorMessageDocumentInCustomization')
      });
    } else {
      this.popupService
        .confirmDelete({
          title: this.translate.instant('customizations.documents.confirmDelete'),
          text: this.translate.instant('customizations.documents.deleteMessage')
        })
        .then(() => this.documentsService.delete(document.id))
        .then(() => this.listComponent.fetch())
        .catch((err) => {
          if (err !== 'cancel') {
            this.popupService.showError({
              title: this.translate.instant('customizations.documents.deleteError'),
              text: err.serverMessage
            });
          }
        });
    }
  }
}
